import i18next from "i18next";

import vi from "./vi";
import en from "./en";

i18next.addResourceBundle("vi", "common", vi);
i18next.addResourceBundle("en", "common", en);
